export default __webpack_public_path__ + "static/media/cn.779853dd.jpg";